import styles from './Checkbox.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from "react";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(fas, fal);



function Checkbox({ checked, onChange, inputColor, value, ...props }) {
    const uncheckedBox = <FontAwesomeIcon icon={["fal", "square"]} className={`${styles.customUncheckbox} ${styles.customCheckbox}`} />;
    const checkedBox = <FontAwesomeIcon icon={["fas", "square-check"]} className={[styles.customCheckedbox, styles.customCheckbox, styles[inputColor]].filter(e => !!e).join(' ')} />;
    //const [isChecked, setIsChecked] = useState(checked);
    const customCheckbox = checked ? checkedBox : uncheckedBox;
    return (
        <div className={styles.checkboxWrapper} {...props}>
            <label>
                <input className={styles.checkbox} value={value} type="checkbox" checked={checked} onChange={(e) => { onChange && onChange(e) }} {...props} />
                {customCheckbox}
                <FontAwesomeIcon icon={["fas", "square"]} className={`${styles.customCheckbox} ${styles.checkboxBackground}`} />
            </label>
        </div>

    )
}

export default Checkbox;